import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../../../shared/components/snackbar/snackbar.component';
import { TranslationService } from '../../translation/translation.service';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  constructor(private snackBar: MatSnackBar, private translationService: TranslationService) { }

  showError(message: string, duration: number = 3000) {
    this.snackBar.openFromComponent(SnackbarComponent, {
      duration: duration,
      data: { message: message, icon: 'error_outline' },
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['snackbar-error']
    });
  }

  showWarning(message: string, duration: number = 3000) {
    this.snackBar.openFromComponent(SnackbarComponent, {
      duration: duration,
      data: { message: message, icon: 'error_outline' },
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['snackbar-warning']
    });
  }

  showSuccess(message: string, duration: number = 3000) {
    this.snackBar.openFromComponent(SnackbarComponent, {
      duration: duration,
      data: { message: message, icon: 'check_circle' },
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['snackbar-success']
    });
  }

  showCustom(message: string, icon: string, duration: number = 3000)
  {
    this.snackBar.openFromComponent(SnackbarComponent, {
      duration: duration,
      data: { message: message, icon: icon},
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['snackbar-custom']
    });
  }
}
